module.exports = __webpack_public_path__ + "img/covers.652d2c79.jpg";